/**
 * banniere.js
 */

// Import
import "./banniere.scss";
import $ from 'jquery';

$(document).ready(function() {

});



